import * as React from 'react';
import { FormControl, FormLabel, FormGroup, FormControlLabel, Checkbox } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme: any) => ({
  formControl: {
    margin: theme.spacing.unit,
    width: '100%',
  },
});

class CheckboxField extends React.PureComponent<any, any> {
  public render() {
    const { field, value, onChange, classes } = this.props;
    return (
      <FormControl className={classes.formControl} required={field.required}>
        <FormLabel component="legend">{field.label}</FormLabel>
        <FormGroup>
          {field.options.map((option: string) => (
            <FormControlLabel
              key={option}
              control={
                <Checkbox
                  id={field.field}
                  name={option}
                  checked={value[option]}
                  onChange={onChange}
                />
              }
              label={option}
            />
          ))}
        </FormGroup>
      </FormControl>
    );
  }
}

export default withStyles(styles)(CheckboxField);



// WEBPACK FOOTER //
// ./src/modules/subscription/components/SubscriptionConfig/CheckboxField.tsx